export const HOC_SESSIONS = {
  "A5.5AV01": {
    eventName: "session_immersed_in_beer",
  },
  A9: {
    eventName: "session_photo_brewer",
  },
  A3: {
    eventName: "session_story_poster",
  },
  "A5.6AV01": {
    eventName: "session_brew_beer",
  },
  "A5.7AV01": {
    eventName: "session_brew_game",
  },
  "A5.8AV01": {
    eventName: "session_ingredients",
  },
  "A8.10AV01": {
    eventName: "session_beer_label",
  },
  A1000: {
    eventName: "session_liverpool",
  },
};
